// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2xw4p","col":"styles_col__1HMjL"};